// src/components/terms/TermsFilterBar.tsx
import * as React from "react";
import Stack from "@mui/material/Stack";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { useSetTermsQuery, useTermsSize } from "src/store/terms/terms.selectors";

type Props = {
  termsType: string;
  termsStatus: string;
  applyStrDatetime: string;
  applyEndDatetime: string;
  order: string;

  onChange: (
    next: Partial<{
      termsType: string;
      termsStatus: string;
      applyStrDatetime: string;
      applyEndDatetime: string;
      order: string;
    }>
  ) => void;

  onSearch: () => void;
  onReset: () => void;
  onCreate: () => void;
};

const SIZE_OPTIONS = [20, 50, 100];
export default function TermsFilterBar({
  termsType,
  termsStatus,
  applyStrDatetime,
  applyEndDatetime,
  order,
  onChange,
  onSearch,
  onReset,
  onCreate,
}: Props) {
  const setQuery = useSetTermsQuery();
  const size = useTermsSize();
  return (
    <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel id="terms-type-label">termsType</InputLabel>
        <Select
          labelId="terms-type-label"
          label="termsType"
          value={termsType}
          onChange={(e) => onChange({ termsType: String(e.target.value) })}
        >
          <MenuItem value="">전체</MenuItem>
          <MenuItem value="SERVICE">SERVICE</MenuItem>
          <MenuItem value="PRIVACY">PRIVACY</MenuItem>
          <MenuItem value="MARKETING">MARKETING</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="terms-status-label">termsStatus</InputLabel>
        <Select
          labelId="terms-status-label"
          label="termsStatus"
          value={termsStatus}
          onChange={(e) => onChange({ termsStatus: String(e.target.value) })}
        >
          <MenuItem value="">전체</MenuItem>
          <MenuItem value="DRAFT">DRAFT(초안)</MenuItem>
          <MenuItem value="PUBLISHED">PUBLISHED(발행)</MenuItem>
          <MenuItem value="DEPRECATED">DEPRECATED(미사용)</MenuItem>
        </Select>
      </FormControl>

      <Button variant="outlined" onClick={onSearch}>
        검색
      </Button>
      <Button variant="contained" onClick={onCreate}>
        약관 등록
      </Button>
    </Stack>
  );
}
